
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jeux/brin/[date]",
      function () {
        return require("private-next-pages/jeux/brin/[date].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jeux/brin/[date]"])
      });
    }
  